<template>
  <span class="scaling-svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34.973"
      height="30.623"
      viewBox="0 0 34.973 30.623"
      class="scaling-svg"
    >
      <g id="Icon_bad" transform="translate(-2.775 -4.25)" color="#b2b1b7">
        <path
          d="M12.75,25.5A12.75,12.75,0,1,1,25.5,12.75,12.764,12.764,0,0,1,12.75,25.5Zm0-22.667a9.917,9.917,0,1,0,9.917,9.917A9.928,9.928,0,0,0,12.75,2.833Z"
          transform="translate(4.25 4.25)"
        />
        <path
          d="M10.729,4.37a1.417,1.417,0,0,1-1.973-.348A3.567,3.567,0,0,0,5.837,2.833,4.481,4.481,0,0,0,2.481,4.144,1.417,1.417,0,1,1,.352,2.275,7.294,7.294,0,0,1,5.85,0a6.346,6.346,0,0,1,5.227,2.4A1.417,1.417,0,0,1,10.729,4.37Z"
          transform="translate(11.333 15.502)"
        />
        <path
          d="M.326,3.4A5.478,5.478,0,0,1,5.725,0a1.417,1.417,0,1,1,0,2.833,2.669,2.669,0,0,0-2.746,1.56,2.956,2.956,0,0,0,.915,3.1,1.417,1.417,0,1,1-2,2A5.77,5.77,0,0,1,.326,3.4Z"
          transform="translate(2.775 7.083)"
        />
        <path
          d="M6.816,3.4A5.478,5.478,0,0,0,1.417,0a1.417,1.417,0,0,0,0,2.833,2.669,2.669,0,0,1,2.746,1.56,2.956,2.956,0,0,1-.915,3.1,1.417,1.417,0,1,0,2,2A5.77,5.77,0,0,0,6.816,3.4Z"
          transform="translate(24.083 7.083)"
        />
      </g>
      <g transform="translate(-188.775 -106.377)">
        <g transform="translate(31.988 -519.945)">
          <g transform="translate(173.887 639.073)">
            <path
              d="M8.936,0a8.936,8.936,0,1,0,8.936,8.936A8.939,8.939,0,0,0,8.936,0Z"
              transform="translate(0 0)"
              fill="#b2b1b7"
            />
          </g>
        </g>
        <rect width="8" height="2" rx="1" transform="translate(211 127)" fill="#fff" />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class RemoveContractorDisabledIcon extends Vue {}
</script>

<style></style>
